import { useEffect, useState } from 'react'

import CloseIcon from '@material-ui/icons/Close'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'

import { Container, SideBarContainer } from './styles'

export const GoalWizardSideBarShell = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsCollapsed(true)
    }, 5000)
    return () => clearTimeout(timer)
  }, [])

  const toggleCollapseSideBar = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <Container style={{ marginRight: isCollapsed ? -300 : 0 }}>
      <div onClick={toggleCollapseSideBar} className='sidebar-collapse-button'>
        {isCollapsed ? (
          <NavigateBeforeIcon fontSize='small' />
        ) : (
          <CloseIcon fontSize='small' />
        )}
      </div>

      <SideBarContainer>{children}</SideBarContainer>
    </Container>
  )
}

export default GoalWizardSideBarShell
